import React from 'react';
import { useTranslation } from 'react-i18next';
import { PositionChip } from '@/components/PositionChip';
import GrayBanner from '@/components/MobileOrganization/Content/GrayBanner';
import { ResolvedPassport } from '@/utils/passport/concurrent';
import {
  getPositionBadges,
  POSITION_BADGE_LABEL,
} from '@/utils/passport/position';

type P = {
  /** `resolveInOrganization` / `resolveAsPerson` / `expandConcurrentPassports` 를 거친 Passport */
  passport: ResolvedPassport;
  /** chip: PC(MUI Chip) · banner: 모바일(회색 배너) */
  variant?: 'chip' | 'banner';
};

/**
 * 임직원 직책 배지(팀장/파트장/겸직)를 렌더합니다.
 *
 * 팀장 대행은 라벨을 노출하지 않습니다(정렬만 위로). `getPositionBadges` 주석 참고.
 *
 * 레이아웃 컨테이너를 두지 않고 배지들만 나열하므로, 간격·정렬은 호출부의
 * 기존 컨테이너를 그대로 따릅니다.
 */
const PositionBadges = ({ passport, variant = 'chip' }: P) => {
  const { t } = useTranslation();
  const badges = getPositionBadges(passport);

  if (badges.length === 0) return null;

  return (
    <>
      {badges.map((badge) =>
        variant === 'banner' ? (
          <GrayBanner key={badge} title={t(POSITION_BADGE_LABEL[badge])} />
        ) : (
          <PositionChip key={badge} label={t(POSITION_BADGE_LABEL[badge])} />
        ),
      )}
    </>
  );
};

export default PositionBadges;
